import Vue from 'vue'
import App from './App.vue'
import router from './router' //引入
import vueSwiper from 'vue-awesome-swiper'
import Antd from 'ant-design-vue';
import axios from 'axios'

import 'ant-design-vue/dist/antd.css';
import 'swiper/swiper-bundle.css'
Vue.use(vueSwiper)
Vue.use(Antd)
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.config.productionTip = false
// import axios from 'axios'
 axios.defaults.baseURL = 'https://jzl.xcx.skyedu.cn'
Vue.prototype.$axios = axios
// http://api.java.coreedu.cn

new Vue({
    router,
  render: h => h(App),
}).$mount('#app')
